import React from 'react'
import PropTypes from 'prop-types'
import ServiceIconMeasures from './ServiceIconMeasures'
import Services from './Services'
import { PARKING_LENGTH, PARKING_HEIGTH } from './utils/constants'

const ParkingServices = ({ measure, value, services, max }) => {
    return (
        <>
            <ServiceIconMeasures measure={measure} value={value} />
            <Services services={services} max={max} />
        </>
    )
}

ParkingServices.propTypes = {
    measure: PropTypes.oneOf([PARKING_LENGTH, PARKING_HEIGTH]),
    value: PropTypes.number,
    services: PropTypes.array,
    max: PropTypes.number,
}

export default ParkingServices
